import { IFormSectionQualifier } from "../../../model/form/FormSectionQualifier";
import { IFormQualifierAttribute } from "../../../model/form/FormQualifierAttribute";
import { IFormSectionPresentationModel } from "./FormSectionPresentationModel";
import FormQualifierAttributePresentationModel, {
  IFormQualifierAttributePresentationModel
} from "./FormQualifierAttributePresentationModel";

export interface TFormSectionQualifierPresentationModel {
  additionalComment: string;
  aggregateFunction: string;
  formSectionId: number;
  label: string;
  labelVisible: boolean;
  orderNumber: number;
  orderNumberVisible: boolean;
  formSectionQualifierId: number;
  qualifierId: number;
  qualifierName: string;
  tooltip: string;
  required: boolean;
  isRequiredFlagVisible: boolean;
  attributes?: IFormQualifierAttributePresentationModel[];
  width: number;
  qualifierCode: string;
}
export interface IFormSectionQualifierPresentationModel
  extends TFormSectionQualifierPresentationModel {
  attributes?: IFormQualifierAttributePresentationModel[];
  formSection: IFormSectionPresentationModel;
}
const isAttributeChanged = (attribute: IFormQualifierAttribute) => {
  let rowsWithValues: number[] = [];
  attribute?.values.forEach((value) => {
    if (value.value !== undefined && value.value !== null) {
      rowsWithValues.push(value.recordOrderNumber);
    }
  });
  return rowsWithValues;
};
const isQualifierRequired = (
  data: IFormSectionQualifier,
  segmentRowsChanged: number[]
) => {
  let requiredQualifiers: number[] = [];
  if (segmentRowsChanged.length > 0) {
    if (data.required) {
      requiredQualifiers = segmentRowsChanged;
    } else {
      data.attributes?.forEach((attribute) => {
        Array.prototype.push.apply(
          requiredQualifiers,
          isAttributeChanged(attribute)
        );
      });
    }
  }

  requiredQualifiers = Array.from(new Set(requiredQualifiers));
  return requiredQualifiers;
};

const FormSectionQualifierPresentationModel = (
  data: IFormSectionQualifier,
  segmentRowsChanged: number[]
): IFormSectionQualifierPresentationModel => {
  let requiredQualifiers = isQualifierRequired(data, segmentRowsChanged);
  let _isRequiredFlagVisible = requiredQualifiers.length > 0;
  let _formSection: IFormSectionPresentationModel = {} as IFormSectionPresentationModel;

  return {
    additionalComment: data.additionalComment,
    aggregateFunction: data.aggregateFunction,
    formSectionId: data.formSectionId,
    label: data.label,
    labelVisible: data.labelVisible,
    orderNumber: data.orderNumber,
    orderNumberVisible: data.orderNumberVisible,
    formSectionQualifierId: data.formSectionQualifierId,
    qualifierId: data.qualifierId,
    qualifierName: data.qualifierName,
    tooltip: data.tooltip,
    required: data.required,
    isRequiredFlagVisible: _isRequiredFlagVisible,
    attributes: data.attributes?.map((item) =>
      FormQualifierAttributePresentationModel(
        item,
        _isRequiredFlagVisible,
        segmentRowsChanged,
        requiredQualifiers
      )
    ),
    formSection: _formSection,
    width: data.width,
    qualifierCode: data.qualifierCode
  };
};

export default FormSectionQualifierPresentationModel;
